import loadable from '@wix/yoshi-flow-editor/loadable';
import React, { type FC, useEffect, useRef } from 'react';

import { useWidget } from '../widgets';

const Toast = loadable(
  () => import(/* webpackChunkName: "Toast" */ '../../common/components/Toast'),
);

const toastFadeOutDelay = 5000;

export const ToastContextProvider: FC<React.PropsWithChildren> = ({
  children,
}) => {
  const displayTimeout = useRef<ReturnType<typeof setTimeout> | undefined>();
  const { ui, handlers } = useWidget();

  const { toast } = ui;
  const { hideToast } = handlers;

  useEffect(() => {
    clearTimeout(displayTimeout.current);

    if (toast.isVisible) {
      displayTimeout.current = setTimeout(hideToast, toastFadeOutDelay);
    }

    return () => clearTimeout(displayTimeout.current);
  }, [toast, hideToast]);

  return (
    <>
      <Toast />
      {children}
    </>
  );
};
